module.exports = __webpack_public_path__ + "img/sweetleaf-collective.6ccd6412.png";